import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: "#1B2A4A",
  },
  container: {
    padding: theme.spacing(2),
    borderRadius: 25,
    backgroundColor: "#f7f7f7",
    marginTop: 10,
    height: "calc(100vh - 235px)",
    overflowY: "auto",
  },

  activityRow: {
    padding: theme.spacing(1.5, 0),
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },

  userName: {
    fontWeight: 600,
    color: "#2c2c2c",
  },

  dateText: {
    fontSize: "0.8rem",
    color: "#7a7a7a",
  },

  messageText: {
    fontSize: "0.9rem",
    color: "#333",
    marginTop: 2,
  },

  divider: {
    marginTop: theme.spacing(1),
  },
}));
